module.exports = __webpack_public_path__ + "img/5.b38c6146.jpg";